import cn from 'clsx';
import { HTMLAttributes, memo, useContext, forwardRef } from 'react';

import GuideContext from '../context';

import s from './GuideImageArea.module.scss';

type Props = HTMLAttributes<HTMLDivElement>;

const GuideImageArea = forwardRef<HTMLDivElement, Props>(({ children, className, ...props }, ref) => {
  const { isCard } = useContext(GuideContext);
  return (
    <div className={cn(s['image-area'], isCard && s['image-area__isCard'], className)} {...props}>
      {children}
    </div>
  );
});
const MemoGuideImageArea = memo(GuideImageArea);
export default MemoGuideImageArea;
